import React from 'react'
import PropTypes from 'prop-types'
import { find } from 'lodash'
import { connect } from 'react-redux'
import Selectors from '../../../../selectors'
import Operations from '../../../../operations'
import { colors, sizes } from '@lmc/common/constants'
import { Spinner, IconSectionHeader } from '../../../../components/generic'
import { LastUpdateBox } from '../../../../components/carePlans'
import FormFields from '../../../../components/forms/FormFields'
import RiskAssessmentOutcome from '../../../../components/forms/screens/RiskAssessmentForm/RiskAssessmentOutcome'
import RiskAssessmentPdfExport from '../../../../components/pdf/RiskAssessmentPdfExport'
import { isBrowser, isTablet } from 'react-device-detect'
import { ButtonOLD, Text } from '@lmc/ui-kit'
import Glyph from '../../../../LEGACY/Glyph'
import Actions from '../../../../actions'
import { withRouter } from '../../../../withRouter'
import { history } from '../../../../store'
import CarePlansPopup from '../../../../components/carePlans/CarePlansPopup'
import dayjs from 'dayjs'
import SeenBySection from './components/SeenBySection'
import RiskAssessmentViewFooter from './components/RiskAssessmentViewFooter'
import BackNavigationHeader from './components/BackNavigationHeader'

const isDesktop = isBrowser || isTablet

export class ResidentRiskAssessmentScreen extends React.Component {
  componentDidMount() {
    const {
      loadListItem,
      router: {
        params: { risk_assessment_id, risk_assessment_history_id },
      },
    } = this.props

    const chosenId = risk_assessment_history_id || risk_assessment_id
    loadListItem('risk-assessments', chosenId)
  }

  componentDidUpdate(prev) {
    const {
      loadListItem,
      router: {
        params: { risk_assessment_id, risk_assessment_history_id },
      },
    } = this.props

    const chosenId = risk_assessment_history_id || risk_assessment_id

    if (prev?.riskAssessment?.id && prev?.riskAssessment?.id !== chosenId) {
      loadListItem('risk-assessments', chosenId)
    }
  }

  goBack = () => history.back()

  onClickHistory = () => {
    const {
      router: {
        params: { id, risk_assessment_id },
      },
    } = this.props
    history.push(
      `/residents/${id}/risk-assessments/${risk_assessment_id}/history`,
    )
  }

  getCarer = () => {
    const { carers, riskAssessment } = this.props
    return find(carers, { id: riskAssessment.createdBy })
  }

  renderFields = () => {
    const { riskAssessment, displayForm } = this.props

    return (
      <div style={styles.sectionContainer}>
        <FormFields
          errors={{}}
          form={displayForm}
          fields={riskAssessment.formData}
          readOnly
          userGenerated
        />
      </div>
    )
  }

  renderCreatedBy = () => {
    const {
      riskAssessment: { createdBy, createdOn, reviewedOn },
      carePlanNominative,
    } = this.props
    const carer = this.getCarer()

    if (createdOn && createdBy && !carer) return null

    const showRiskAssessmentCarePlansPopup =
      !!this.props?.riskAssessment?.carePlans?.length

    return (
      <LastUpdateBox
        carer={carer}
        date={reviewedOn || createdOn}
        style={styles.lastUpdateBox}
        rightChildren={
          <div
            style={{
              marginLeft: 'auto',
              marginRight: 5,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {showRiskAssessmentCarePlansPopup ? (
              <>
                <Text as="p2">Attachments:</Text>
                <CarePlansPopup
                  riskAssessmentCarePlans={this.props.riskAssessment?.carePlans}
                  carePlanNominative={carePlanNominative}
                />
              </>
            ) : null}
          </div>
        }
      />
    )
  }

  renderHeader = () => {
    const {
      router: {
        params: { risk_assessment_history_id },
      },
      resident,
      riskAssessment,
      riskAssessmentPDF,
    } = this.props

    const pdfTitle = `${resident.name.first} ${resident.name.last} - ${riskAssessment.form.name}`
    return (
      <div>
        <BackNavigationHeader onBack={this.goBack} />
        <div
          style={{
            ...styles.titleContainer,
            marginLeft: isDesktop && !riskAssessment.form.iconText ? 55 : 0,
          }}
        >
          <IconSectionHeader
            isMainHeader
            title={riskAssessment.form.name}
            iconText={riskAssessment.form.iconText}
            color={riskAssessment.form.color}
          />
          <div style={styles.containerButton}>
            {!risk_assessment_history_id && (
              <ButtonOLD
                id="risk-assessment-history"
                onClick={this.onClickHistory}
                style={styles.historyButton}
                type="secondary"
                icon={<Glyph name="book" />}
              >
                History
              </ButtonOLD>
            )}
            {isDesktop && (
              <RiskAssessmentPdfExport
                carer={this.getCarer()}
                id="risk-assessment-pdf-download-button"
                resident={resident}
                riskAssessment={riskAssessmentPDF}
                title={pdfTitle}
              />
            )}
          </div>
        </div>
      </div>
    )
  }

  renderOutcomes = () => {
    const {
      resident,
      riskAssessment: { form, riskLevel, riskScore },
    } = this.props

    if (this.props.form && !this.props.form.hasRiskScore) return null

    return (
      <div style={styles.sectionContainer}>
        <Text color="black" style={{ opacity: 0.7 }} as="h4">
          Risk Outcome Score
        </Text>
        <div style={styles.fieldContainer}>
          <RiskAssessmentOutcome
            hasActions={this.props.form.hasActions}
            resident={resident}
            risk={{
              level: riskLevel,
              score: riskScore,
            }}
          />
        </div>
      </div>
    )
  }

  renderActions = () => {
    const { riskAssessment, form } = this.props
    if (form && !form.hasActions) return null
    return (
      <div style={styles.sectionContainer}>
        <Text color="black" style={{ opacity: 0.7 }} as="h4">
          Actions to mitigate this risk
        </Text>
        {riskAssessment.formData.actions && (
          <div
            className="lmc-card"
            style={{
              ...styles.fieldContainer,
              ...styles.cardContainer,
            }}
          >
            {riskAssessment.formData.actions}
          </div>
        )}
      </div>
    )
  }

  renderSeenBy = () => {
    const { riskAssessment, carers } = this.props
    const avatars = riskAssessment.seenBy.map((user) => {
      const currentUser = carers.find((carer) => carer.id === user.userId)
      if (!currentUser) return null
      return {
        url: currentUser.picture,
        name: `${currentUser.name.first} ${currentUser.name.last}`,
        viewedOn: `Viewed on: ${dayjs(user.timestamp).format('DD/MM/YYYY')}`,
      }
    })
    const filteredAvatars = avatars.filter(Boolean)
    return <SeenBySection filteredAvatars={filteredAvatars} />
  }

  renderFooter = () => {
    const {
      riskAssessment,
      router: {
        params: { risk_assessment_history_id },
      },
      hasAccess,
    } = this.props

    const hasRolePermission = hasAccess(
      ['carehome-admin', 'senior-carer'],
      [
        {
          i: 'update',
          this: 'RiskAssessment',
        },
      ],
    )

    if (risk_assessment_history_id) return
    return (
      <RiskAssessmentViewFooter
        onEdit={() => this.props.openRiskAssessmentModal(riskAssessment)}
        hasEditPermission={hasRolePermission}
        isHistoryView={!!risk_assessment_history_id}
      />
    )
  }

  render() {
    const { riskAssessment } = this.props
    if (!riskAssessment || !riskAssessment.formData) return <Spinner />
    return (
      <div style={styles.container}>
        {this.renderHeader()}
        {this.renderCreatedBy()}
        {this.renderFields()}
        {this.renderOutcomes()}
        {this.renderActions()}
        {this.renderSeenBy()}
        {this.renderFooter()}
      </div>
    )
  }
}

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    paddingTop: 24,
    marginBottom: 100,
  },
  fieldContainer: {},
  historyButton: {
    marginRight: 10,
  },
  lastUpdateBox: {
    marginTop: 24,
  },
  sectionContainer: {
    paddingBottom: 40,
  },
  titleContainer: {
    paddingTop: 21,
    display: 'flex',
    background: colors.white,
    padding: '18px 22px',
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 12,
  },
  containerButton: {
    display: 'flex',
  },
  cardContainer: {
    background: colors.white,
    padding: '18px 24px',
    whiteSpace: 'pre-wrap',
    width: '100%',
    fontWeight: 500,
    color: colors.black,
    fontSize: 16,
  },
}

const RISK_ASSESSMENT_MODAL_ID = 'createRiskAssessment'
const FORM_ID = 'editCarePlan'

ResidentRiskAssessmentScreen.propTypes = {
  carers: PropTypes.array,
  loadListItem: PropTypes.func.isRequired,
  form: PropTypes.object,
  resident: PropTypes.object,
  riskAssessment: PropTypes.object,
}

const mapStateToProps = (state, props) => {
  const {
    router: {
      params: { id, risk_assessment_id, risk_assessment_history_id },
    },
  } = props
  const chosenId = risk_assessment_history_id || risk_assessment_id

  return {
    carers: state.data.carers,
    riskAssessment: Selectors.formatRiskAssessment(state, {
      resident: id,
      risk_assessment: chosenId,
    }),
    riskAssessmentPDF: Selectors.formatRiskAssessmentPDF(state, {
      resident: id,
      risk_assessment: chosenId,
    }),
    form: Selectors.formatFieldsForAssessment(state, props),
    displayForm: Selectors.formatFieldsForAssessmentDisplay(state, props),
    resident: find(state.data.residents, { id }),
    carePlanNominative: state.global.home.preferredCarePlansNominative,
    hasAccess: (roles, abilities) =>
      Selectors.checkRoleAccess(state, { roles, abilities }),
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadListItem: (list_id, item_id) =>
    dispatch(Operations.loadListItem(list_id, item_id)),
  openRiskAssessmentModal: (completedRiskAssessment) => {
    dispatch(
      Actions.openModal({
        modalId: RISK_ASSESSMENT_MODAL_ID,
        data: { completedRiskAssessment, parentFormId: FORM_ID },
      }),
    )
  },
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResidentRiskAssessmentScreen),
)
